// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3TmPr","ranges":"BmiRanges_ranges__rMr6U"};